<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table 
                            :settings="tableConfig" 
                            :table-items="tableItems" 
                            @load-items="getTableData" 
                            @row-click="clickToRowItem" 
                            @delete-items="deleteItems" 
                            @new-item="newItem"
                            @export="exportCSV"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="data" v-if="['Draft','Cancelled','Submitted'].indexOf(data.item.status) === -2">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:invoice_date" slot-scope="data">{{data.item.invoice_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}</template>
                            <template slot="gofix_table:amount" slot-scope="data">{{data.item.amount | formatMoney}}</template>
                            <template slot="gofix_table:gst" slot-scope="data">{{data.item.gst | formatMoney}}</template>
                            <template slot="gofix_table:total" slot-scope="data">{{data.item.total | formatMoney}}</template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="AP Invoice" hide-footer :centered="true" ref="edit-ap-invoice">
                <b-form>
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input-date v-model="invoice_date_edit" label="Invoice Date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-supplier v-if="!checkSupplierUser()" label="Supplier Name" :contract-id="ClientContractID ? ClientContractID.id : null" :required="true" v-model="supplier">
                            </gofix-form-supplier>
                            <gofix-form-dropdown v-else
                                    label="Supplier Name"
                                    vLabel="name"
                                    :clearable="false"
                                    :required="true"
                                    :show-icon-required="true"
                                    v-model="supplier"
                                    :options="supplierOption">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input label="Supplier Invoice Ref No" v-model="supplier_invoice_ref_no_edit" autocomplete="false"></gofix-form-input>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-number label="Invoice Amount" v-model="supplier_invoice_ref_total_edit" prefix="$">
                            </gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.ap_invoice, 'create')">
                    <gofix-button label="CANCEL" @click="cancel" noBorder dark></gofix-button>
                    <gofix-button label="SUBMIT" @click="saveApInvoice" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
          <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
              <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.export.process}}</span>
              </b-progress-bar>
            </b-progress>
          </b-modal>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { filters } from "@/_filterVar.js";
import moment from 'moment';
const accounting = require("accounting");

export default {
    name: "ap-invoice",
    data() {
        let filter = JSON.parse(JSON.stringify(filters["ap_invoice"]));
        return {
            tableConfig: {
                name: "ap-invoice-listing",
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "desc",
                controls: {
                    create: this.$checkRole(this.$accessModule.ap_invoice, "create"), //this.orderType !== 'Preventive'
                    delete: this.$checkRole(this.$accessModule.ap_invoice, "delete")
                }
            },
            tableItems: [],
            supplier: null,
            isAction: false,
            supplier_invoice_ref_no_edit: '',
            tax_code_edit: '',
            supplier_invoice_ref_total_edit: '',
            creditor_code_edit: '',
            billing_address_edit: '',
            invoice_date_edit: null,
            modals:{
              export:{
                open:false,
                loading:false,
                process:'Creating file csv',
                title: 'Export Data'
              }
            },
            supplierOption:[],
        };
    },
    filters: {},
    watch: {
        supplier: function(val) {
            if (val) {
                if (val.billing_address) {
                    var address = '';
                    if (val.billing_address.building_no)
                        address = val.billing_address.building_no
                    address = address.concat(' ', val.billing_address.street_name, ' ', val.billing_address.unit_no, ' ', val.billing_address.building_name, ' ', val.billing_address.postal_code, ' ', val.billing_address.country);
                    address = address.replace(/null/gi, "").replace(/\s+/g, ' ');
                    this.billing_address_edit = address
                }
                this.creditor_code_edit = val.creditor_code
            } else {
                this.billing_address_edit = ''
                this.creditor_code_edit = ''
            }
        }
    },
    computed: {
        ...mapGetters({
            ClientContractID: "ContractController/ClientContractID",
            Item: "ApInvoiceController/Item",
            UserLogin: 'AuthController/user',
        })
    },
    created() {},
    methods: {
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            await this.$store
                .dispatch("ApInvoiceController/getAppInvoiceList", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    this.$alertNotification("Can not load AP invoice", "danger");
                    reject();
                });
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store
                .dispatch("ApInvoiceController/deleteApInvoice", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'ap_invoice'))
                })
                .catch(err => {
                    reject();
                });
        },
        async newItem(callback) {
            if (!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Contract required", "danger");
            }
            let user_supplier = this.checkSupplierUser();
            this.invoice_date_edit = null
            this.supplier = null
            this.supplier_invoice_ref_no_edit = ''
            this.tax_code_edit = ''
            this.supplier_invoice_ref_total_edit = ''
            this.creditor_code_edit = ''
            this.billing_address_edit = ''
            this.isAction = false
            if(user_supplier){
                this.supplier = {
                    id: this.UserLogin && this.UserLogin.organisation_id,
                    name: this.UserLogin && this.UserLogin.organization && this.UserLogin.organization.name
                };
                this.supplierOption = [this.supplier];
            }
            this.$refs["edit-ap-invoice"].show();
        },
        async clickToRowItem(item) {
            this.$store.commit('ApInvoiceController/getApInvoice', item);
            this.$router.push(`/v2/ap-invoice/${item.id}`)
        },
        cancel() {
            this.$refs["edit-ap-invoice"].hide();
        },
        saveApInvoice() {
            if (!this.invoice_date_edit) {
                return this.$alertNotification("Invoice date is required", "danger");
            }
            if (!this.supplier || !this.supplier.id) {
                return this.$alertNotification("Supplier required", "danger");
            }
            let data = {
                invoice_date: this.invoice_date_edit ? moment(this.invoice_date_edit).format('YYYY-MM-DD') : null,
                supplier_id: this.supplier.id,
                supplier_invoice_ref_no: this.supplier_invoice_ref_no_edit,
                supplier_invoice_ref_total: this.supplier_invoice_ref_total_edit ? Number(accounting.unformat(this.supplier_invoice_ref_total_edit)) : "",
                creditor_code: this.creditor_code_edit,
                supplier_name: this.supplier.name,
                billing_address: this.billing_address_edit,
                tax_code: this.tax_code_edit,
                client_contract_id: this.ClientContractID.id,
                ids: []
            }
            let api = 'createApInvoice';
            let keyMessage = 'adding';

            this.isAction = true
            this.$store.dispatch(`ApInvoiceController/${api}`, data)
                .then(async data => {
                    this.$refs["edit-ap-invoice"].hide();
                    await this.$router.push("/v2/ap-invoice/" + this.Item.id)
                    await this.$alertNotification(this.$notificationV2(keyMessage, 'ap_invoice'));
                })
                .catch(err => {
                    console.log(err);
                })
        },
      exportCSV(){
        let params = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
        let that = this;
        this.modals.export.open = true;
        this.modals.export.process = "Creating file csv";

        global.axios.get(`/api/ap-invoice/export`, {
          params: params,
          responseType: 'blob',
          onDownloadProgress (progress) {
            that.modals.export.process = "Downloading";
          }
        })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'ap-invoice.csv'); //or any other extension
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.modals.export.open = false
            })
            .catch(error => {
              this.modals.export.open = false
              console.log(error);
            });
      },
        checkSupplierUser(){
            if(this.UserLogin.organization && this.UserLogin.organization.is_supplier)
                return true;
            return false;
        }
    }
};
</script>